import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
type Role = 'host' | 'cleaner' | 'manutentore';
interface DemoAccount {
  role: Role;
  label: string;
  email: string;
  password: string;
  avatar: string;
}
const demoAccounts: DemoAccount[] = [{
  role: 'host',
  label: 'Host',
  email: 'massimo.giri@host.it',
  password: 'demo-host',
  avatar: 'https://cdn.magicpatterns.com/uploads/aDiier9xTcmPNhp9njGfUz/80.jpg'
}, {
  role: 'cleaner',
  label: 'Cleaner Manager',
  email: 'cleaner@manager.it',
  password: 'demo-cleaner',
  avatar: 'https://cdn.magicpatterns.com/uploads/5qDLCxcppx3Xbyc5uL4GS6/Screenshot_2026-03-22_alle_16.12.18.png'
}, {
  role: 'manutentore',
  label: 'Manutentore',
  email: 'tecnico@manutenzione.it',
  password: 'demo-tecnico',
  avatar: 'https://cdn.magicpatterns.com/uploads/fTors2Yrr32xiEFMswChLH/Installatore-E-Manutentore-Meccanico.webp'
}];
const roleRoutes: Record<Role, string> = {
  host: '/dashboard',
  cleaner: '/cm',
  manutentore: '/man'
};
export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<Role>('host');
  const fillAccount = (account: DemoAccount) => {
    setEmail(account.email);
    setPassword(account.password);
    setRole(account.role);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    localStorage.setItem('cleanai_onboarded', '1');
    navigate(roleRoutes[role]);
  };
  return <main className="min-h-screen w-full bg-background flex items-center justify-center p-4" data-id="element-3173">
      <div className="w-full max-w-sm" data-id="element-3174">
        {/* Logo */}
        <div className="text-center mb-8" data-id="element-3175">
          <h1 className="text-2xl font-bold text-navy" data-id="element-3176">
            Clean<span className="text-coral" data-id="element-3177">AI</span>
          </h1>
          <p className="text-sm text-muted-foreground mt-1" data-id="element-3178">
            Accedi al tuo account
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-xl border border-border shadow-sm p-6" data-id="element-3179">
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3180">
            <div data-id="element-3181">
              <label htmlFor="email" className="block text-xs font-medium text-navy mb-1.5" data-id="element-3182">
                Email
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@esempio.it" required className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-3183" />
            </div>
            <div data-id="element-3184">
              <label htmlFor="password" className="block text-xs font-medium text-navy mb-1.5" data-id="element-3185">
                Password
              </label>
              <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-3186" />
            </div>
            <button type="submit" className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-coral text-white rounded-xl text-sm font-semibold hover:bg-coral-600 transition-colors min-h-[48px]" data-id="element-3187">
              <LogIn size={18} data-id="element-3188" />
              Accedi
            </button>
          </form>
        </div>

        {/* Quick-access shortcuts */}
        <div className="mt-6" data-id="element-3189">
          <div className="flex items-center gap-3 mb-3" data-id="element-3190">
            <div className="flex-1 h-px bg-border" data-id="element-3191" />
            <span className="text-[11px] uppercase tracking-wider font-medium text-muted-foreground" data-id="element-3192">
              Accesso rapido demo
            </span>
            <div className="flex-1 h-px bg-border" data-id="element-3193" />
          </div>
          <div className="space-y-2" data-id="element-3194">
            {demoAccounts.map(account => <button key={account.role} type="button" onClick={() => fillAccount(account)} className="w-full flex items-center gap-3 px-3 py-2.5 bg-white border border-border rounded-lg hover:border-coral hover:bg-coral/5 transition-colors text-left min-h-[44px]" data-id="element-3195">
                <img src={account.avatar} alt="" className="w-10 h-10 rounded-full object-cover object-center border border-border flex-shrink-0" data-id="element-3196" />
                <span className="block text-sm font-medium text-navy leading-tight min-w-0 truncate" data-id="element-3197">
                  {account.label}
                </span>
              </button>)}
          </div>
        </div>
      </div>
    </main>;
}